import {
  ProvisioningSource,
  ProvisioningSourceFilter,
} from '@/activityLog/bulkProvisioning/constants/provisioningSource.ts';
import { useSourceTranslation } from '@/activityLog/bulkProvisioning/Filters/hooks/useSourceTranslation.ts';
import { Chip } from 'common/components/Chips/Chip.tsx';
import { useTranslation } from 'react-i18next';

export type SourceChipsProps = {
  source: ProvisioningSourceFilter;
  onDelete: (source: ProvisioningSource) => void;
};

export const SourceChips = ({ source, onDelete }: SourceChipsProps) => {
  const { t } = useTranslation();
  const translateSourceValue = useSourceTranslation();

  return (
    <>
      {source.map((source) => {
        return (
          <Chip
            key={source}
            label={`${t('bulkProvisioning.source')}: ${translateSourceValue(source)}`}
            size="medium"
            variant="outlined"
            onDelete={() => onDelete(source)}
          />
        );
      })}
    </>
  );
};
